// import { getPlaiceholder } from "plaiceholder";
const NEXT_PUBLIC_WP_URL = process.env.NEXT_PUBLIC_WP_URL;
const NEXT_PUBLIC_SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;

import {
  GraphQLTypes,
  InputType,
  MediaItemSizeEnum,
  PostObjectFieldFormatEnum,
  Selector,
} from "./zeus";

import { gql } from "@apollo/client";
import client, { chain } from "../apollo-client";

async function fetchAPI(query, { variables }: { variables?: any } = {}) {
  try {
    const { data } = await client.query({
      query: gql`
        ${query}
      `,
      variables,
    });

    return cloneJson(data);
  } catch (error) {
    console.log({ error });
  }
}

const generateBlurhash = async (src) => {
  // temporarily disabling to check if it is causing the build issue on server
  return null;

  // const { blurhash, img } = await getPlaiceholder(src, { size: 16 });
  // return blurhash.hash;
};

const replaceAppUrl = (postContent) => {
  if (!postContent || postContent == undefined) return "";

  try {
    const anchorRegExp = new RegExp(`href="${NEXT_PUBLIC_WP_URL}`, "g");
    postContent = (postContent as string).replace(anchorRegExp, `href="`);
  } catch (error) {
    console.log("API level error " + error, {
      postContentType: typeof postContent,
    });
  }

  return postContent;
};

export const resolveAll = async (promises) => {
  const data = [];

  for (const promise of promises) {
    data.push(await promise);
  }

  return data;
};

export async function getPreviewPost(id) {
  const data = await fetchAPI(
    `
    query PreviewPost($id: ID!, $idType: PostIdType!) {
      post(id: $id, idType: $idType) {
        databaseId
        slug
        status
      }
    }`,
    {
      variables: { id },
    }
  );
  return data.post;
}

// Single Blog
export async function getAllPostsWithSlug() {
  const totalNumber = 1000;
  const limit = 100;

  let lastCursorValue;
  let finalData;

  for (let count = 0; count <= totalNumber; count += limit) {
    if (lastCursorValue != "loops_ends") {
      const response = await chain("query")({
        posts: [
          {
            first: limit,
            after: lastCursorValue,
          },
          {
            pageInfo: {
              hasNextPage: true,
            },
            edges: {
              node: {
                slug: true,
              },
              cursor: true,
            },
          },
        ],
      });

      const edges = response?.posts?.edges;
      const lastEdge = edges[edges?.length - 1];

      if (finalData) {
        //push new data into old object - this is not for the first time
        (finalData?.posts?.edges as any[]).push(...edges);
      } else {
        //this is for the first time
        finalData = response;
      }

      if (response.posts.pageInfo.hasNextPage == true) {
        lastCursorValue = lastEdge.cursor;
      } else {
        lastCursorValue = "loops_ends";
      }
    }
  }
  const data = finalData;

  // const data = await fetchAPI(`
  //   {
  //     posts(first: 1000) {
  //       edges {
  //         node {
  //           slug
  //         }
  //       }
  //     }
  //   }
  // `);

  return data?.posts;
}

//////// Front Page /////////////////
export async function getAllPostsForHome(preview) {
  const data = await fetchAPI(
    `
    query AllPosts {
      posts(first: 6, where: { orderby: { field: DATE, order: DESC } }) {
        edges {
          node {
            title
            excerpt
            slug
            date
            featuredImage {
              node {
                sourceUrl
              }
            }
            categories {
              edges {
                node {
                  id
                  name
                  uri
                }
              }
            }
            author {
              node {
                name
                firstName
                lastName
                avatar {
                  url
                }
              }
            }
          }
        }
      }
    }
  `,
    {
      variables: {
        onlyEnabled: !preview,
        preview,
      },
    }
  );

  let posts = data?.posts ?? [];

  posts.edges = await Promise.all(
    posts.edges.map(async (edge) => {
      if (!edge.node.featuredImage) return edge;
      edge.node.featuredImage.node.blurhash = await generateBlurhash(
        edge.node.featuredImage.node.sourceUrl
      );
      return edge;
    })
  );

  return posts;
}

const cloneJson = (json) => {
  try {
    return JSON.parse(JSON.stringify(json));
  } catch (error) {
    console.log(error);
  }
};

////// Single Blog Page //////////
export async function getPostAndMorePosts(slug, preview, previewData) {
  const postPreview = preview && previewData?.post;
  // The slug may be the id of an unpublished post
  const isId = Number.isInteger(Number(slug));
  const isSamePost = isId
    ? Number(slug) === postPreview.id
    : slug === postPreview.slug;
  const isDraft = isSamePost && postPreview?.status === "draft";
  const isRevision = isSamePost && postPreview?.status === "publish";
  const query = `
  fragment AuthorFields on User {
    name
    firstName
    lastName
    description
    uri
    avatar {
      url
    }
  }
  fragment PostFields on Post {
    title
    excerpt
    slug
    date
    uri
    seo {
      title
      metaDesc
      fullHead
      canonical
      metaRobotsNofollow
      metaRobotsNoindex              
    }
    featuredImage {
      node {
        sourceUrl
      }
    }
    author {
      node {
        ...AuthorFields
      }
    }
    categories {
      edges {
        node {
          id
          name
          uri
        }
      }
    }
    tags {
      edges {
        node {
          id
          name
          uri
        }
      }
    }
  }
  query PostBySlug($id: ID!, $idType: PostIdType!) {
    post(id: $id, idType: $idType) {
      ...PostFields
      content
      ${
        // Only some of the fields of a revision are considered as there are some inconsistencies
        isRevision
          ? `
      revisions(first: 1, where: { orderby: { field: MODIFIED, order: DESC } }) {
        edges {
          node {
            title
            excerpt
            content
            author {
              ...AuthorFields
            }
          }
        }
      }
      `
          : ""
      }
    }
    posts(first: 6, where: { orderby: { field: DATE, order: DESC } }) {
      edges {
        node {
          ...PostFields
        }
      }
    }
  }
`;
  // const data = await fetchAPI(
  //   query,
  //   {
  //     variables: {
  //       id: isDraft ? postPreview.id : slug,
  //       idType: isDraft ? "DATABASE_ID" : "SLUG",
  //     },
  //   }

  // );

  const { data } = await client.query({
    query: gql`
      ${query}
    `,
    variables: {
      id: isDraft ? postPreview.id : slug,
      idType: isDraft ? "DATABASE_ID" : "SLUG",
    },
  });

  const jsonData = cloneJson(data);

  const post = jsonData?.post;
  const posts = jsonData?.posts;

  // Draft posts may not have an slug
  if (isDraft) post.slug = postPreview.id;
  // Apply a revision (changes in a published post)
  if (isRevision && post.revisions) {
    const revision = post.revisions.edges[0]?.node;

    if (revision) Object.assign(post, revision);
    delete post.revisions;
  }

  // Filter out the main post
  posts.edges = posts.edges.filter(({ node }) => node.slug !== slug);
  // If there are still 3 posts, remove the last one
  if (posts.edges.length > 2) posts.edges.pop();
  if (posts.edges.length > 4) posts.edges.pop();
  if (posts.edges.length > 6) posts.edges.pop();

  //generate blurhash
  post.author.node.avatar.blurhash = await generateBlurhash(
    post.author.node.avatar.url
  );

  jsonData.post.content = replaceAppUrl(jsonData?.post.content);
  //jsonData.post.seo.canonical = replaceAppUrl(jsonData?.post.seo.canonical);

  return jsonData;
}

/* New */

/*export async function getAllPageWithSlug() {
  const data = await fetchAPI(`
    {
      page(first: 10000) {
        nodes {
          title
          content
        }
      }
    }
  `);
  return data?.categories;
}

export async function getAllAuthors(preview) { //getAll author
  const data = await fetchAPI(
    `
    query page {
      users {
        edges {
          nodes {
            email
            firstName
            lastName
            avatar {
              url
            }
            username
          }
        }
      }
    }
  `,
    {
      variables: {
        onlyEnabled: !preview,
        preview,
      },
    }
  )

  return data?.posts
}

export async function getPageData(id, idType = "DATABASE_ID") {
  const data = await fetchAPI(
    `
    query PreviewPost($id: ID!, $idType: PostIdType!) {
      page(id: $id, idType: $idType) {
        id
        databaseId
        title
        content
      }
    }`,
    {
      variables: { id, idType },
    }
  );
  return data.pages;
}

/*export async function getPageBySlug(slug) {
  return graphQL(
    `query PageBySlug($slug: String!) {
      pageBy(uri: $slug) {
        title
        content(format: RENDERED)
        slug
      }
    }`,
    { slug }
  );
}

export async function getAllPages(preview) {
  const data = await fetchAPI(`
    {
      pages(first: 10) {
        edges {
          node {
            name              
            slug
            content
          }
        }
      }
    }
  `);

  return data?.pages;
}*/

/* New End */
///////// sidebar Posts ////////////
/*
export async function getSidebarLatestPosts(preview) {
  const data = await fetchAPI(
    `
    query AllPosts {
      posts(first: 5, where: { orderby: { field: DATE, order: DESC } }) {
        edges {
          node {
            title
            excerpt
            slug
            date
            featuredImage {
              node {
                sourceUrl
              }
            }
            categories {
              edges {
                node {
                  id
                  name
                  uri
                }
              }
            }
            author {
              node {
                name
                firstName
                lastName
                avatar {
                  url
                }
              }
            }
          }
        }
      }
    }
  `,
    {
      variables: {
        onlyEnabled: !preview,
        preview,
      },
    }
  );

  return data?.posts;
} */

/*
export async function getSidebarPopularPosts(preview) {
  const data = await fetchAPI(
    `
    query AllPosts {
      posts(first: 5, where: { orderby: { field: COMMENT_COUNT, order: DESC } }) {
        edges {
          node {
            title
            excerpt
            slug
            date
            featuredImage {
              node {
                sourceUrl
              }
            }
            categories {
              edges {
                node {
                  id
                  name
                  uri
                }
              }
            }
            author {
              node {
                name
                firstName
                lastName
                avatar {
                  url
                }
              }
            }
          }
        }
      }
    }
  `,
    {
      variables: {
        onlyEnabled: !preview,
        preview,
      },
    }
  );

  return data?.posts;
} */

/////////// Categories ////////
const categoryWithSlugSelector = Selector("Category")({
  slug: true,
  parent: {
    node: {
      slug: true,
    },
  },
});

export type CategoryWithSlug = InputType<
  GraphQLTypes["Category"],
  typeof categoryWithSlugSelector
>;

const categorySelector = Selector("Category")({
  id: true,
  name: true,
  uri: true,
  slug: true,
  seo: {
    title: true,
    metaDesc: true,
    fullHead: true,
    canonical: true,
    metaRobotsNofollow: true,
    metaRobotsNoindex: true,
  },
  description: true,
  categoryColor: {
    accentColor: true,
    accentBackground: true,
  },
});

export type Category = InputType<
  GraphQLTypes["Category"],
  typeof categorySelector
>;

const postSelector = Selector("Post")({
  date: true,
  id: true,
  title: [
    {
      format: PostObjectFieldFormatEnum.RENDERED,
    },
    true,
  ],
  content: [
    {
      format: PostObjectFieldFormatEnum.RENDERED,
    },
    true,
  ],
  slug: true,
  categories: [
    {
      first: 10,
    },
    {
      edges: {
        node: categorySelector,
      },
    },
  ],
  featuredImage: {
    node: {
      sourceUrl: [
        {
          size: MediaItemSizeEnum.LARGE,
        },
        true,
      ],
    },
  },
});

const catPostSelector = Selector("Post")({
  date: true,
  id: true,
  title: [
    {
      format: PostObjectFieldFormatEnum.RENDERED,
    },
    true,
  ],
  slug: true,
  categories: [
    {
      first: 10,
    },
    {
      edges: {
        node: categorySelector,
      },
    },
  ],
  featuredImage: {
    node: {
      sourceUrl: [
        {
          size: MediaItemSizeEnum.LARGE,
        },
        true,
      ],
    },
  },
});

/* POSTS FROM CATEGORY */
export type CategoryWithPosts = InputType<
  GraphQLTypes["Category"],
  typeof categoryWithPostsSelector
>;

const categoryWithPostsSelector = Selector("Category")({
  ...categorySelector,
  posts: [
    {
      first: 6,
    },
    {
      pageInfo: {
        hasNextPage: true,
        hasPreviousPage: true,
        endCursor: true
      },
      edges: {
        node: catPostSelector,
      },
    },
  ],
});

export async function getAllCatWithSlug() {
  const data = await chain("query")({
    categories: [
      {
        first: 10000,
      },
      {
        edges: {
          node: categoryWithSlugSelector,
        },
      },
    ],
  });

  return data.categories;
}

export async function getCatData(slugs: string[]) {
  const data = await chain("query")({
    categories: [
      {
        where: {
          slug: slugs,
        },
      },
      {
        edges: {
          node: categoryWithPostsSelector,
        },
      },
    ],
  });

  return data?.categories;
}


export async function getNewCatData(slugs: string[], afterData = null) {
  const data = await fetchAPI(`
    {   
      categories (where: {slug: "${slugs}"}) {
        edges {
          node {
            id
            name
            uri
            slug
            seo {
              title
              metaDesc
              fullHead
              canonical
              metaRobotsNofollow
              metaRobotsNoindex
            },
            description
            categoryColor {
              accentColor
              accentBackground
            },
          }
        }
        nodes {
          posts(first: 6, after: "${afterData}") {
            pageInfo {
              hasNextPage
              hasPreviousPage
              endCursor
            }
            edges {
              node {
                date
                id
                title
                slug
                categories(first: 1) {
                  edges {
                    node {
                      id
                      name
                      slug
                      uri
                    }
                  }
                }
                featuredImage {
                  node {
                    sourceUrl(size: LARGE)
                  }
                }
              }
            }            
          }
        }      

      }
    }
  `);
  return data?.categories;
}

/////////// Tags ///////////
export async function getAllTagWithSlug() {
  const data = await chain("query")({
    tags: [
      {
        first: 10000,
      },
      {
        edges: {
          node: {
            slug: true,
          },
          cursor: true,
        },
      },
    ],
  });

  return data?.tags;

  /*
  const totalNumber = 1000;
  const limit = 100;

  let lastCursorValue;
  let finalData;

  for (let count = 0; count <= totalNumber; count += limit) {

      if(lastCursorValue != 'loops_ends') {
          const response = await chain("query")({
            tags: [
              {
                first: limit,
                after: lastCursorValue,
              },
              {
                pageInfo: {
                  hasNextPage: true,
                },
                edges: {
                  node: {
                    slug: true,
                  },
                  cursor: true,
                },
              },
            ],
          });

          const edges = response?.tags?.edges;
          const lastEdge = edges[edges?.length - 1];
          
          if (finalData) { //push new data into old object - this is not for the first time
            (finalData?.tags?.edges as any[]).push(...edges);     
          } else { //this is for the first time
            finalData = response;
          }

          if(response.tags.pageInfo.hasNextPage == true  ) {
              lastCursorValue = lastEdge.cursor;
          } else {
            lastCursorValue = 'loops_ends'
          }
      }
  }
  const data = finalData;
  return data?.tags; */
}

export async function getTagBlogs(slug: string) {
  const data = await chain("query")({
    tags: [
      {
        where: {
          search: slug,
        },
      },
      {
        edges: {
          node: {
            slug: true,
            uri: true,
            description: true,
            name: true,
            seo: {
              canonical: true,
              fullHead: true,
              metaDesc: true,
              metaRobotsNofollow: true,
              metaRobotsNoindex: true,
              title: true,
            },
          },
        },
      },
    ],
  });

  //let posts = data?.posts ?? { edges: [] };

  return data?.tags;
}

export async function getTagData(slug, preview = false) {
  const data = await fetchAPI(`
    {   
      tags(where: {slug: "${slug}"}) {
        edges {
          node {
            slug
            uri
            description
            name
            seo {
              title
              metaDesc
              fullHead
              canonical
              metaRobotsNofollow
              metaRobotsNoindex              
            }
            posts {
              edges {
                node {
                  date
                  id
                  title
                  slug
                  categories {
                    edges {
                        node {
                        id
                        name
                        uri
                        }
                    }
                  }
                  featuredImage {
                    node {
                        sourceUrl
                    }
                  }
                }
              }
            }
          }
        }
      } 
    }
  `);
  return data?.tags;
}

/////////// Authors ///////////
export async function getAllAuthorWithSlug() {
  const data = await chain("query")({
    users: [
      {
        first: 10000,
      },
      {
        edges: {
          node: {
            slug: true,
          },
        },
      },
    ],
  });

  return data?.users;
}

export async function getAuthorData(slug, preview, previewData) {
  const data = await fetchAPI(`
    {   
      users(where: {nicenameIn: "${slug}"}) {
        edges {
          node {
            slug
            uri
            description
            name
            seo {
              title
              metaDesc
              fullHead
              canonical
              metaRobotsNofollow
              metaRobotsNoindex              
            }
            avatar {
              url
            }
            posts {
              edges {
                node {
                  date
                  id
                  title
                  slug
                  categories {
                    edges {
                        node {
                        id
                        name
                        uri
                        }
                    }
                  }
                  featuredImage {
                    node {
                        sourceUrl
                    }
                  }
                }
              }
            }
          }
        }
      } 
    }
  `);
  //return data?.users;

  let users = data?.users ?? [];

  users.edges = await Promise.all(
    users.edges.map(async (edge) => {
      edge.node.avatar.blurhash = await generateBlurhash(edge.node.avatar.url);
      return edge;
    })
  );

  return users;
}

//category wise post home page
export async function getHomeCatData(limit: number, slug, preview) {
  const data = await fetchAPI(`
    {   
      categories(where: {slug: "${slug}"}) {
        edges {
          node {
            slug
            uri
            name
            categoryColor {
              accentColor
              accentBackground
            }
            posts(first: ${limit}){
              edges {
                node {
                  date
                  id
                  title
                  slug
                  categories {
                    edges {
                        node {
                        id
                        name
                        uri
                        }
                    }
                  }
                  featuredImage {
                    node {
                      sourceUrl
                    }
                  }
                }
              }
            }
          }
        }
      } 
    }
  `);
  return data?.categories;
}

////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////// FINAL GRAPHQL ////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////
/*********** Celebrity Post **************/
//////////////////////////////////////////
const celebritySelector = Selector("Celebrity")({
  id: true,
  date: true,
  uri: true,
  title: [{ format: PostObjectFieldFormatEnum.RENDERED }, true],  
  slug: true,
  content: [{ format: PostObjectFieldFormatEnum.RENDERED }, true],
  excerpt: [{ format: PostObjectFieldFormatEnum.RENDERED }, true],
  featuredImage: {
    node: {
      guid: true,
    },
  },
  seo: {
    title: true,
    metaDesc: true,
    fullHead: true,
    canonical: true,
    metaRobotsNofollow: true,
    metaRobotsNoindex: true,
  }
  
});

const celebrityProfSelector = Selector("Celebrity")({
  id: true,
  date: true,
  uri: true,
  title: [{ format: PostObjectFieldFormatEnum.RENDERED }, true],  
  slug: true,
  excerpt: [{ format: PostObjectFieldFormatEnum.RENDERED }, true],
  featuredImage: {
    node: {
      guid: true,
    },
  },
  profession: [
    {
      first: 10
    },
    {
      edges: {
        node: {
          id: true,
          slug: true,
          name: true,
          uri: true,
        }
      }
    }
  ],
  seo: {
    title: true,
    metaDesc: true,
    fullHead: true,
    canonical: true,
    metaRobotsNofollow: true,
    metaRobotsNoindex: true,
  }
  
});

export async function getAllCelebrity() {
  //all celebrity

  const data = await chain("query")({
    allCelebrity: [
      {
        first: 100,
      },
      {
        edges: {
          node: celebrityProfSelector,
        },
      },
    ],
  });

  data.allCelebrity?.edges?.map(async (edge) => {
    const fImg = edge.node?.featuredImage;
    if (fImg) {
      fImg["blurhash"] = await generateBlurhash(fImg.node?.guid);
      fImg["url"] = await fImg.node?.guid;
      fImg["src"] = await fImg.node?.guid;
    }
    return edge;
  });

  return data?.allCelebrity.edges;
}

export async function getCelebsAndMorePosts(
  slug: string,
  preview,
  previewData
) {
  //celebrity details

  const postPreview = preview && previewData?.post;
  // The slug may be the id of an unpublished post
  const isId = Number.isInteger(Number(slug));
  const isSamePost = isId
    ? Number(slug) === postPreview.id
    : slug === postPreview.slug;
  const isDraft = isSamePost && postPreview?.status === "draft";
  const isRevision = isSamePost && postPreview?.status === "publish";

  const data = await chain("query")({
    celebrityBy: [
      {
        slug,
      },
      celebritySelector,
    ],
  });

  //generate blurhash
  const fi = data.celebrityBy.featuredImage;
  if (fi) {
    fi["blurhash"] = await generateBlurhash(fi.node.guid);
    fi["url"] = fi.node.guid;
    fi["src"] = fi.node.guid;
  }

  // data.celebrityBy.excerpt = replaceAppUrl(data?.celebrityBy?.excerpt);
  // data.celebrityBy.content = replaceAppUrl(data?.celebrityBy?.content);

  // console.log(data)
  return data;
}

//////////////////////////////
/**** Inner Page Content ****/
//////////////////////////////
export async function getFrontPageContent(slug, preview) {
  const data = await fetchAPI(
    `query AllPosts {
      pages(where: {title: "Front Page"}) {
        edges {
          node {
            slug
            title
            seo {
              title
              metaDesc
              fullHead
              canonical
              metaRobotsNofollow
              metaRobotsNoindex              
            }
          }
        }
      }
    }
    `
  );
  return data?.pages;
}

export async function getInnerPageContent(slug, preview) {
  const data = await fetchAPI(
    `query AllPosts($slug: String!) {
      pages(where: {name: $slug}) {
        nodes {
          title
          content
          seo {
            title
            metaDesc
            fullHead
            canonical
            metaRobotsNofollow
            metaRobotsNoindex              
          }
        }        
      }
    }`,
    {
      variables: {
        onlyEnabled: !preview,
        preview,
        slug,
      },
    }
  );
  return data?.pages;
}

//////////////////////////////
/******** Professions *******/
//////////////////////////////
export async function getProfessions(preview) {
  const data = await fetchAPI(
    `query cat {
      allProfession {
        edges {
          node {
            name
            uri
            slug
          }
        }
      }
    }`,
    {
      variables: {
        onlyEnabled: !preview,
        preview,
      },
    }
  );
  return data?.allProfession;
}


export async function getProfessionsBySlug(slug, preview) {
  const data = await fetchAPI(
    `{
      allProfession(where: {slug: "${slug}"}) {
        edges {
          node {
            id
            name
            slug
            seo {
              title
              metaDesc
              fullHead
              canonical
              metaRobotsNofollow
              metaRobotsNoindex              
            }            
            celebrity {
              edges {
                node {
                  title
                  uri
                  excerpt
                  featuredImage {
                    node {
                        guid
                    }
                  }                  
                }
              }
            }
          }
        }
      }
    }
  `,
    {
      variables: {
        onlyEnabled: !preview,
        preview,
        slug,
      },
    }
  );

  return data?.allProfession;
}

/////////////////////////////////////////////////////
/************* Latest & Popular Posts **************/
/////////////////////////////////////////////////////
const blogSelector = Selector("Post")({
  id: true,
  date: true,
  title: [{ format: PostObjectFieldFormatEnum.RENDERED }, true],
  slug: true,
  excerpt: [{ format: PostObjectFieldFormatEnum.RENDERED }, true],
  content: [{ format: PostObjectFieldFormatEnum.RENDERED }, true],
  featuredImage: {
    node: {
      sourceUrl: true,
      guid: true,
    },
  },
  categories: {
    edges: {
      node: {
        id: true,
        name: true,
        uri: true,
      },
    },
  },
  author: {
    node: {
      name: {
        firstName: true,
        lastName: true,
        avatar: {
          uri: true,
        },
      },
    },
  },
});

export async function getLatestBlogs(limit: number, preview = false) {
  const data = await fetchAPI(
    `
    query AllPosts {
      posts(first: ${limit}, where: { orderby: { field: DATE, order: DESC } }) {
        edges {
          node {
            title
            slug
            date
            featuredImage {
              node {
                sourceUrl
              }
            }
            categories {
              edges {
                node {
                  id
                  name
                  uri
                }
              }
            }
            author {
              node {
                name
                firstName
                lastName
                avatar {
                  url
                }
              }
            }
          }
        }
      }
    }
  `,
    {
      variables: {
        onlyEnabled: !preview,
        preview,
      },
    }
  );

  let posts = data?.posts ?? [];

  posts.edges = await Promise.all(
    posts.edges.map(async (edge) => {
      if (!edge.node.featuredImage) return edge;
      edge.node.featuredImage.node.blurhash = await generateBlurhash(
        edge.node.featuredImage.node.sourceUrl
      );
      return edge;
    })
  );

  return posts;
}

export async function getPopularBlogs(limit: number, preview) {
  const data = await fetchAPI(
    `
    query AllPosts {
      posts(first: ${limit}, where: { orderby: { field: COMMENT_COUNT, order: DESC } }) {
        edges {
          node {
            title
            slug
            date
            featuredImage {
              node {
                sourceUrl
              }
            }
            categories {
              edges {
                node {
                  id
                  name
                  uri
                }
              }
            }
            author {
              node {
                name
                firstName
                lastName
                avatar {
                  url
                }
              }
            }
          }
        }
      }
    }
  `
  );

  let posts = data?.posts ?? [];

  posts.edges = await Promise.all(
    posts.edges.map(async (edge) => {
      if (!edge.node.featuredImage) return edge;
      edge.node.featuredImage.node.blurhash = await generateBlurhash(
        edge.node.featuredImage.node.sourceUrl
      );
      return edge;
    })
  );

  return posts;
}

export async function getTrendingBlogs(limit: number, preview) {
  const data = await fetchAPI(
    `query AllPosts {
      posts(first: ${limit}, where: {orderby: {field: AUTHOR, order: DESC}}) {
        edges {
          node {
            title
            slug
            date
            featuredImage {
              node {
                sourceUrl
              }
            }
            categories {
              edges {
                node {
                  id
                  name
                  uri
                }
              }
            }
            author {
              node {
                name
                firstName
                lastName
                avatar {
                  url
                }
              }
            }
          }
        }
      }
    }`
  );

  let posts = data?.posts ?? [];

  posts.edges = await Promise.all(
    posts.edges.map(async (edge) => {
      if (!edge.node.featuredImage) return edge;
      edge.node.featuredImage.node.blurhash = await generateBlurhash(
        edge.node.featuredImage.node.sourceUrl
      );
      return edge;
    })
  );

  return posts;
}

//////////////////////////////////////
////////////// SEARCH ////////////////
//////////////////////////////////////
const searchPostSelector = Selector("Post")({
  title: [{ format: PostObjectFieldFormatEnum.RENDERED }, true],
  slug: true,
  date: true,
  featuredImage: {
    node: {
      guid: true,
    },
  },
});

export type SearchPost = InputType<
  GraphQLTypes["Post"],
  typeof searchPostSelector
>;

export async function searchBlogs(searchString) {
  const data = await chain("query")({
    posts: [
      {
        where: {
          search: searchString,
        },
        first: 12,
      },
      {
        edges: {
          node: searchPostSelector,
        },
      },
    ],
  });

  let posts = data?.posts ?? { edges: [] };

  if (posts?.edges) {
    posts.edges = await Promise.all(
      posts.edges.map(async (edge) => {
        edge.node.featuredImage.node["blurhash"] = await generateBlurhash(
          edge.node.featuredImage.node["sourceUrl"]
        );
        return edge;
      })
    );
  }

  return posts;
}



/* */
export async function getCelebByProfession(slug) {

  const data = await fetchAPI(
    `{
      allProfession(where: {slug: "${slug}"}) {
        edges {
          node {
            name
            slug           
            celebrity {
              edges {
                node {
                  title
                  uri
                  excerpt
                  featuredImage {
                    node {
                        guid
                    }
                  }                  
                }
              }
            }
          }
        }
      }
    }
  `    
  );

  return data?.allProfession;
}


/***************** All Slug ******************/
export async function getAllBlogSlugs(afterSlug: string = null) {
  const data = await fetchAPI(
    `
    query AllPosts {
      posts(first: 100, after: ${afterSlug}) {
        edges {
          node {   
            uri         
            slug            
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  `
  );
  return data?.posts;
}



export async function getAllPostsForFeed() {
  const totalNumber = 1000;
  const limit = 100;

  let lastCursorValue;
  let finalData;

  for (let count = 0; count <= totalNumber; count += limit) {
    if (lastCursorValue != "loops_ends") {
      const response = await chain("query")({
        posts: [
          {
            first: limit,
            after: lastCursorValue,
          },
          {
            pageInfo: {
              hasNextPage: true,
            },
            edges: {
              node: {
                title: [{ format: PostObjectFieldFormatEnum.RENDERED }, true],
                slug: true,
                excerpt: [{ format: PostObjectFieldFormatEnum.RENDERED }, true],
                date: true,
              },
              cursor: true,
            },
          },
        ],
      });

      const edges = response?.posts?.edges;
      const lastEdge = edges[edges?.length - 1];

      if (finalData) {
        //push new data into old object - this is not for the first time
        (finalData?.posts?.edges as any[]).push(...edges);
      } else {
        //this is for the first time
        finalData = response;
      }

      if (response.posts.pageInfo.hasNextPage == true) {
        lastCursorValue = lastEdge.cursor;
      } else {
        lastCursorValue = "loops_ends";
      }
    }
  }
  const data = finalData;

  return data?.posts;
}